// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import UnitedArabEmirates from '../_raw/flag/icon_flag_united_arab_emirates.png';

export default () => <img src={UnitedArabEmirates} alt="UnitedArabEmirates" />;
